// Facebook 影片外掛：只有畫面上真的有 .fb-video 時才載入 SDK（原本每頁都載約 180KB，拖慢 PageSpeed）
let loading = null

function loadSdk() {
  if (window.FB && window.FB.XFBML) return Promise.resolve()
  if (loading) return loading
  loading = new Promise(resolve => {
    if (!document.getElementById('fb-root')) {
      const root = document.createElement('div')
      root.id = 'fb-root'
      document.body.prepend(root)
    }
    const js = document.createElement('script')
    js.id = 'facebook-jssdk'
    js.async = true
    js.defer = true
    js.crossOrigin = 'anonymous'
    js.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v16.0'
    js.onload = () => resolve()
    js.onerror = () => { loading = null; resolve() }
    document.body.appendChild(js)
  })
  return loading
}

export function parseFbVideos() {
  if (!document.querySelector('.fb-video')) return
  loadSdk().then(() => {
    if (window.FB && window.FB.XFBML) window.FB.XFBML.parse()
  })
}
